import { render, staticRenderFns } from "./report-status-text.vue?vue&type=template&id=1e2e60a7"
import script from "./report-status-text.vue?vue&type=script&lang=js"
export * from "./report-status-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports